module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-supplier"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('div', {
    attrs: {
      "id": "supplier"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38bf8dc2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-supplier.vue
// module id = 145
// module chunks = 7 8 10 11 12 13 14 15 16 17 18 19